export const SITE_URL = "readybusinesscl.maximquiz.com";
